import { GRAHA_LORE, NAKSHATRA_LORE } from "@/lib/jyotishaLore";

// Shared editorial tokens. Larger, more legible than the original micro-text
// while preserving the manuscript hierarchy (mono small-caps label → serif value).
const LABEL = "text-[11px] font-mono uppercase tracking-[0.25em] text-ink-muted";
const VALUE = "text-[15px] text-ink leading-snug";

export const GrahaCard = ({ graha }) => {
  // graha is {sa, en, eng, glyph, role}
  const lore = GRAHA_LORE[graha.en];
  if (!lore) return null;
  return (
    <div className="px-6 py-5">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="font-sanskrit text-[28px] text-terracotta leading-none mb-1.5">{graha.sa}</div>
          <div className="font-display text-2xl text-ink leading-none" style={{ fontWeight: 500 }}>
            {graha.en}
            <span className="text-ink-muted text-sm font-body font-normal ml-2">· {graha.eng}</span>
          </div>
        </div>
        <span className="text-3xl text-[var(--gold-soft)] leading-none mt-1" style={{ fontFamily: "Georgia, serif" }}>
          {graha.glyph}
        </span>
      </div>

      <p className="font-display-italic text-[17px] text-ink leading-relaxed border-l-2 border-terracotta pl-4 my-5">
        "{lore.teaching}"
      </p>

      <div className="grid grid-cols-2 gap-x-6 gap-y-4 mt-5 pt-5 border-t border-[var(--hairline)]">
        <div>
          <div className={LABEL + " mb-1"}>Karaka</div>
          <div className={VALUE}>{lore.karaka}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Rules</div>
          <div className={VALUE}>{lore.rules}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Exalted · Debilitated</div>
          <div className={VALUE}>{lore.exalted.replace(/ \d+°/, "")} · {lore.debilitated.replace(/ \d+°/, "")}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Day · Gem</div>
          <div className={VALUE}>{lore.day.split(" ·")[0]} · {lore.gem.split(" (")[0]}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Element</div>
          <div className={VALUE}>{lore.element} · {lore.guna.split(" ")[0]}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Friends</div>
          <div className={VALUE}>{lore.friends}</div>
        </div>
      </div>

      <div className="mt-5 pt-5 border-t border-[var(--hairline)] flex items-baseline gap-4">
        <div className={LABEL + " shrink-0"}>Mantra</div>
        <div className="text-[15px] text-ink font-sanskrit flex-1 leading-snug">{lore.mantra}</div>
      </div>
    </div>
  );
};

export const NakshatraCard = ({ nakshatra, index }) => {
  // nakshatra is {sa, en, ruler, deity}
  const lore = NAKSHATRA_LORE[nakshatra.en];
  if (!lore) return null;
  return (
    <div className="px-6 py-5">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-terracotta mb-2">
            Nakshatra · {String(index + 1).padStart(2, "0")} / 27
          </div>
          <div className="font-sanskrit text-[28px] text-ink leading-none mb-1.5">{nakshatra.sa}</div>
          <div className="font-display text-2xl text-ink leading-none" style={{ fontWeight: 500 }}>
            {nakshatra.en}
          </div>
        </div>
        <div className="text-right pl-4 shrink-0">
          <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-ink-muted mb-1">Ruler</div>
          <div className="text-sm text-terracotta font-display" style={{ fontWeight: 500 }}>{nakshatra.ruler}</div>
        </div>
      </div>

      <p className="font-display-italic text-[17px] text-ink leading-relaxed border-l-2 border-terracotta pl-4 my-5">
        "{lore.teaching}"
      </p>

      <div className="grid grid-cols-2 gap-x-6 gap-y-4 mt-5 pt-5 border-t border-[var(--hairline)]">
        <div>
          <div className={LABEL + " mb-1"}>Deity</div>
          <div className={VALUE}>{lore.deity}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Symbol</div>
          <div className={VALUE}>{lore.symbol}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Range</div>
          <div className={VALUE}>{lore.range}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Gana · Yoni</div>
          <div className={VALUE}>{lore.gana.split(" ")[0]} · {lore.yoni.split(" ")[0]}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Quality</div>
          <div className={VALUE}>{lore.quality.split(" ·")[0]}</div>
        </div>
        <div>
          <div className={LABEL + " mb-1"}>Padas · Sound</div>
          <div className={VALUE}>{lore.pada_count} · {lore.sound}</div>
        </div>
      </div>
    </div>
  );
};
